import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export function SuggestedConnectButton({
    loading,
    onClick,
}: {
    loading: boolean;
    onClick: () => void;
}) {
    return (
        <ViewTableCell captureClicks>
            <ButtonWithLoader
                variant="primary"
                size="sm"
                type="button"
                loading={loading}
                onClick={onClick}
            >
                Connect
            </ButtonWithLoader>
        </ViewTableCell>
    );
}
